import { CSSProperties } from 'react'

export const s = {
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  } as CSSProperties,
  text: {
    width: 504,
    margin: '12px 48px 32px',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '32px',
  } as CSSProperties,
  button: {
    borderColor: '#595959',
    fontWeight: 600,
  } as CSSProperties,
}
